module.exports = __webpack_public_path__ + "img/We've moved_th.2f0fb57.png";